(() => {
  /**
   * Uses Swiper package to create a carousel
   * More info: https://swiperjs.com/
   */
  if (customElements.get('features-slider')) {
    return;
  }

  class FeaturesSlider extends HTMLElement {
    constructor() {
      super();
      this.tabletMatchQuery = window.matchMedia('(min-width: 750px)');
      this.slider = null;
      this.options = {
        slidesPerView: 3,
        spaceBetween: 6,
        pagination: {
          el: this.querySelector('[data-pagination]'),
          type: 'bullets',
          clickable: true,
        },
      };
    }

    handleResize = debounce(() => {
      this.initSlider();
    }, 300);

    /**
     * Init slider.
     *
     * @returns {Void}
     */
    initSlider() {
      if (this.tabletMatchQuery.matches) {
        if (this.slider?.destroyed) return;
        return this.destroy();
      }
      if (!!this.querySelector('.swiper-initialized')) return;
      this.slider = new Swiper(this.sliderElement, this.options);
    }

    /**
     * Destroy.
     */
    destroy() {
      if (this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy(true, true);
      }
    }

    /**
     * Toggle listeners.
     *
     * @param {Boolean} shouldRemove
     */
    toggleListeners(shouldRemove = false) {
      const method = shouldRemove ? 'removeEventListener' : 'addEventListener';
      window[method]('resize', this.handleResize);
    }

    /**
     * Disconnected callback.
     */
    disconnectedCallback() {
      this.toggleListeners('remove');
    }

    /**
     * Connected callback.
     *
     * @returns {Void}
     */
    connectedCallback() {
      this.sliderElement = this.querySelector('[data-slider]');
      if (!this.sliderElement) return;

      this.toggleListeners();
      this.initSlider();
    }
  }

  customElements.define('features-slider', FeaturesSlider);
})();
